import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "content-box-details" }
const _hoisted_2 = { class: "content-title" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = {
  key: 1,
  class: "subtitle"
}
const _hoisted_6 = { class: "content-details" }
const _hoisted_7 = { class: "features" }
const _hoisted_8 = { class: "feature-name" }
const _hoisted_9 = {
  key: 2,
  class: "plus"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/')))
    }),
    _createElementVNode("div", _hoisted_2, [
      (!$setup.isDesktop)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString($setup.props.title.join(" ")), 1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.props.title, (line) => {
            return (_openBlock(), _createElementBlock("h1", {
              class: "title",
              key: line
            }, _toDisplayString(line), 1))
          }), 128))
    ]),
    ($setup.isDesktop)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Boost engagement from prospective", -1),
          _createElementVNode("br", null, null, -1),
          _createTextVNode("buyers. Effortlessly showcase lot", -1),
          _createElementVNode("br", null, null, -1),
          _createTextVNode("availability in ", -1),
          _createElementVNode("span", { class: "bold" }, "real time.", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("h2", _hoisted_5, [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Boost engagement from prospective buyers. Effortlessly showcase lot availability in ", -1),
          _createElementVNode("span", { class: "bold" }, "real time.", -1)
        ]))])),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.features, (feature) => {
          return (_openBlock(), _createElementBlock("li", { key: feature }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "content-checkmark" }, [
              _createElementVNode("div", { class: "checkmark" })
            ], -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(feature), 1)
          ]))
        }), 128))
      ])
    ]),
    ($props.isSignUpView)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, "PLUS more!"))
      : _createCommentVNode("", true)
  ]))
}